module.exports = __webpack_public_path__ + "static/media/Teviot House Cherry Post unit (2).fa74a55a.jpg";